import { render, staticRenderFns } from "./ClearDBModal.vue?vue&type=template&id=d37f356e&scoped=true&"
import script from "./ClearDBModal.vue?vue&type=script&lang=js&"
export * from "./ClearDBModal.vue?vue&type=script&lang=js&"
import style0 from "./ClearDBModal.vue?vue&type=style&index=0&id=d37f356e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37f356e",
  null
  
)

export default component.exports